import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { EntityLink } from "scmp-app/components/entity-link";

import ImagePlusFlag from "./img-plus.svg";

export const StyledImagePlusFlag = styled(ImagePlusFlag)`
  grid-area: plus-flag;

  margin-block-end: 8px;
`;

export const StyledEntityLink = styled(EntityLink)`
  display: block;

  color: #000000;
`;

type ContainerProps = {
  $showPlusFlag: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: grid;
  grid: ${props =>
    props.$showPlusFlag
      ? `
    "plus-flag" min-content
    "section" min-content
    "headline" min-content
    "summary" min-content
    "cover-image" min-content
    "action-bar" min-content
    / 100%`
      : `
    "section" min-content
    "headline" min-content
    "summary" min-content
    "cover-image" min-content
    "action-bar" min-content
    / 100%`};

  :hover {
    ${ContentHeadline}, ${SponsorHeadline} {
      color: #2c4692;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    grid: ${props =>
      props.$showPlusFlag
        ? `
      "plus-flag cover-image" min-content
      "section cover-image" min-content
      "headline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      / minmax(0, 1fr) minmax(0, 216px)`
        : `
      "section cover-image" min-content
      "headline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      / minmax(0, 1fr) minmax(0, 216px)`};

    column-gap: 32px;
  }
`;

export const Section = styled.div`
  grid-area: section;

  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: 120%;
  text-transform: uppercase;
`;

export const Headline = styled.div`
  grid-area: headline;

  margin-block-start: 8px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
`;

export const Summary = styled.div`
  grid-area: summary;

  display: none;

  margin-block-start: 12px;

  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 130%;

  font-feature-settings:
    "clig" off,
    "liga" off;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }

  ${StyledEntityLink} {
    color: #6f6f6f;
  }
`;

export const ActionBar = styled.div`
  grid-area: action-bar;

  margin-block-start: 12px;

  time {
    color: #999999;
    font-weight: 400;
    font-size: 12px;
    font-family: ${fontRoboto};
    line-height: 120%;
  }
`;

export const CoverImage = styled.div`
  ${Figure} {
    aspect-ratio: 3/2;
    ${theme.breakpoints.up("tablet")} {
      max-inline-size: 216px;
      max-block-size: 144px;
    }
  }
`;

type ImageContainerProps = {
  $isShowCoverImage: boolean;
};
export const ImageContainer = styled.div<ImageContainerProps>`
  grid-area: cover-image;

  position: relative;

  display: ${props => (props.$isShowCoverImage ? "block" : "none")};

  margin-block-start: 8px;

  ${theme.breakpoints.up("tablet")} {
    display: block;

    margin-block-start: 0;
  }
`;
